import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Editor } from '@tiptap/core';
import { IDocumentDto } from '../../documents/dto/document-listing.dto';
import { DocumentListingApiService } from '../../documents/document-listing.api.service';
import { DocumentViewVariantEnum } from '../../documents/store/document-listing.reducers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, filter, Subject, takeUntil } from 'rxjs';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';

@Component({
  selector: 'app-internal-linking',
  templateUrl: './internal-linking.component.html',
  styleUrl: './internal-linking.component.scss'
})
export class InternalLinkingComponent implements OnInit, OnDestroy {

  constructor(
    private documentListingApiService: DocumentListingApiService,
    private ngbActiveModal: NgbActiveModal,
    private _extractSenderDetails$: ExtractSenderDetailPipe
  ) { }

  @Input()
  set _editor(editor: Editor) {
    this.editor = editor;
  }
  get _editor(): Editor {
    return this.editor;
  }
  private editor: Editor;
  public searchTerm = '';
  public documents: IDocumentDto[];
  private searchSubject = new Subject<string>();
  private destroyed = new Subject<void>();
  public loader:boolean = false;
  ngOnInit() {
    this.searchSubject
      .pipe(
        takeUntil(this.destroyed),
        debounceTime(300),
        distinctUntilChanged(),
        filter(term => term.length >= 3 || term.length === 0)
      )
      .subscribe(term => {
        if (!term) {
          return this.documents; // load full list
        }
        this.loader = true;
        this.documentListingApiService
          .getDocuments(DocumentViewVariantEnum.table_view, { search: term })
          .subscribe({
            next: (response) => {
              this.documents = response?.data;
              this.loader = false;
            },
            error: () => {
              this.loader = false;
              this.documents = [];
            }
          })
      });
  }

  searchDocuments() {
    this.searchSubject.next(this.searchTerm.trim().toLowerCase());
  }

  closeModal() {
    this.ngbActiveModal.close();
  }

  selectDocument(document: IDocumentDto) {
    const senderRole = this._extractSenderDetails$.transform(document['recipient_roles']);
     if (!senderRole || !senderRole.recipient_role_detail) {
      console.warn('Could not find sender details for the selected document.');
      // Optionally, show a toast message to the user and do not close the modal.
      return;
    }
    const { id } = senderRole;
    const { unique_id } = senderRole.recipient_role_detail;
    const url = `/#/sender/${id}/${unique_id}`;

    this.editor.chain()
      .focus()
      .insertContent({
        type: 'text',
        text: document?.visible_name || document.name,
        marks: [{
          type: 'link',
          attrs: { href: url, docId: document.id }
        }]
      }).run();
      
    this.closeModal();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}